const getAsapLabel = time => `ASAP${time ? ` (${time} mins)` : ''}`;

export default getAsapLabel;

export const getAsapLabelRange = (timeRange = []) =>
  getAsapLabel(timeRange.length ? timeRange.join('-') : '');
